export class UserRole {
  static readonly ProductOwner = 'product_owner';
  static readonly SystemAdmin = 'System Administrator';
  static readonly Editor = 'Editor';
  static readonly Viewer = 'Viewer';

  static readonly AllRoles: { label: string; value: string }[] = [
    { label: 'Product Owner', value: UserRole.ProductOwner },
    { label: 'System Admin', value: UserRole.SystemAdmin },
    { label: 'Editor', value: UserRole.Editor },
    { label: 'Viewer', value: UserRole.Viewer }
  ];
}

// Define permissions
export const Permissions = [
  {
    module: 'Categories',
    key: 'categories',
    actions: [
      { key: 'categories_view', label: 'View', selected: false },
      { key: 'categories_add', label: 'Add', selected: false },
      { key: 'categories_edit', label: 'Edit', selected: false },
      { key: 'categories_archive', label: 'Archive', selected: false },
    ],
  },
  {
    module: 'SOPs',
    key: 'sops',
    actions: [
      { key: 'sops_view_draft', label: 'View Draft', selected: false },
      { key: 'sops_view', label: 'View Published', selected: false },
      { key: 'sops_add', label: 'Add', selected: false },
      { key: 'sops_edit', label: 'Edit', selected: false },
      { key: 'sops_submit', label: 'Submit', selected: false },
      { key: 'sops_publish', label: 'Approve', selected: false },
      { key: 'sops_archive', label: 'Archive', selected: false },
    ],
  },
  {
    module: 'Users',
    key: 'users',
    actions: [
      { key: 'users_view', label: 'View', selected: false },
      { key: 'users_add', label: 'Add', selected: false },
      { key: 'users_edit', label: 'Edit', selected: false },
      { key: 'users_active', label: 'Active', selected: false },
      { key: 'users_inactive', label: 'Inactive', selected: false },
    ],
  }
] ;